const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
const isFirefox = navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
const isChromium = window.chrome;

const sectionHeader = document.querySelector(".section-header");
const headerWrapper = document.querySelector(".header-wrapper");
const imageBanner = document.querySelector(".new-image-banner-wrapper");

if (isFirefox || isSafari || isChromium) {
  document.body.style.background = "#fff";
  sectionHeader.classList.remove("backdrop-filter-30");
  const blurEffectDiv = createBlurEffectDiv();
  // add blurEffectDiv after section-header
  sectionHeader.insertAdjacentElement("afterend", blurEffectDiv);
  if (imageBanner && sectionHeader) {
    imageBanner.style.marginTop = -sectionHeader.offsetHeight + "px";
    blurEffectDiv.style.display = "none";
    sectionHeader.classList.remove("mix-blend-mode-difference");
    blurEffectDiv.classList.remove("backdrop-filter-30");
  } else {
    sectionHeader.classList.add("mix-blend-mode-difference");
    setTimeout(() => {
      sectionHeader.classList.add("mix-blend-mode-difference");
    }, 10);
  }

  if (imageBanner) {
    window.addEventListener("scroll", () => {
      const scrollY = window.scrollY;
      const bannerEnd = imageBanner.offsetTop + imageBanner.clientHeight;
      if (scrollY >= sectionHeader.offsetHeight) {
        if (getPosition(sectionHeader) === "sticky") {
          blurEffectDiv.style.display = "block";
        } else {
          blurEffectDiv.style.display = "none";
        }
        blurEffectDiv.classList.add("backdrop-filter-30");
      } else {
        blurEffectDiv.style.display = "none";
      }
      if (scrollY >= bannerEnd) {
        sectionHeader.classList.add("mix-blend-mode-difference");
      } else {
        sectionHeader.classList.remove("mix-blend-mode-difference");
      }
    });
  }
} else {
  (function () {
    if (sectionHeader && imageBanner) {
      imageBanner.style.marginTop = -sectionHeader.offsetHeight + "px";
      sectionHeader.classList.remove("mix-blend-mode-difference");
      sectionHeader.classList.remove("backdrop-filter-30");
    }
    window.addEventListener("scroll", () => {
      // Get the scroll position and image banner position
      const scrollY = window.scrollY;
      const bannerEnd = imageBanner?.offsetTop + imageBanner?.clientHeight;
      // When scrolling past the image banner's top + header's height, apply blur effect and remove 'absolute' position
      if (scrollY > headerWrapper.offsetHeight) {
        headerWrapper.classList.add("backdrop-filter-30"); // Apply blur effect
        sectionHeader.classList.remove("backdrop-filter-30"); // Remove blur from section header if it exists
      } else {
        headerWrapper.classList.remove("backdrop-filter-30"); // Remove blur effect
      }
      // When scroll is over the end of image banner, change mix-blend-mode to 'difference' and apply blur to section header
      if (scrollY >= bannerEnd) {
        sectionHeader.classList.remove("section-header-initial-text-color"); // Remove initial text color
        // Change mix-blend-mode to 'difference'
        if (isFirefox || isSafari) {
          sectionHeader.classList.remove("mix-blend-mode-difference");
        } else {
          sectionHeader.classList.add("mix-blend-mode-difference");
        }
        sectionHeader.classList.add("backdrop-filter-30"); // Apply blur effect to section header
        headerWrapper.classList.remove("backdrop-filter-30"); // Remove blur from header wrapper
      } else {
        sectionHeader.classList.add("section-header-initial-text-color"); // add initial text color
        sectionHeader.classList.remove("mix-blend-mode-difference");
        sectionHeader.classList.remove("backdrop-filter-30"); // Remove blur from section header if scroll is above banner end
      }
    });
  })();
}
function getPosition(element) {
  const style = window.getComputedStyle(element);
  return style.position;
}
function createBlurEffectDiv() {
  const blurEffectDiv = document.createElement("div");
  blurEffectDiv.id = "blur-effect-div";
  blurEffectDiv.style.display = "block";
  // blurEffectDiv.style.height = sectionHeader.offsetHeight + "px";
  // blurEffectDiv.style.marginTop = -sectionHeader.offsetHeight + "px";
  blurEffectDiv.style.top = 36 + "px";
  blurEffectDiv.classList.add("blur-effect-div", "backdrop-filter-30", "top-0");
  return blurEffectDiv;
}
